import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";

const css = `
  .auth-page { min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px; }
  .auth-card { background:var(--card); border:1px solid var(--border); border-radius:20px; padding:40px; max-width:400px; width:100%; }
  .auth-logo { font-family:var(--head); font-size:28px; font-weight:800; letter-spacing:2px; margin-bottom:8px; }
  .auth-logo span { color:var(--blue); }
  .auth-card h2 { font-family:var(--head); font-size:26px; font-weight:800; letter-spacing:1px; margin-bottom:6px; }
  .auth-card p  { color:var(--muted); font-size:14px; margin-bottom:28px; }
  .auth-fields  { display:flex; flex-direction:column; gap:16px; margin-bottom:20px; }
  .auth-footer  { text-align:center; margin-top:20px; color:var(--muted); font-size:14px; }
  .auth-footer a { color:var(--blue); font-weight:500; }
  .auth-error   { color:var(--danger); font-size:13px; text-align:center; margin-bottom:12px; }
`;

export default function Login() {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError("Incorrect email or password.");
      setLoading(false);
    }
    // App.jsx will redirect to /dashboard on session change
  };

  return (
    <>
      <style>{css}</style>
      <div className="auth-page">
        <div className="auth-card fade-in">
          <div className="auth-logo">NEO<span> DETAIL</span></div>
          <h2>WELCOME BACK</h2>
          <p>Sign in to your dashboard</p>
          <form onSubmit={handleLogin}>
            <div className="auth-fields">
              <div className="form-group">
                <label>Email</label>
                <input type="email" placeholder="you@email.com" value={email}
                  onChange={e => setEmail(e.target.value)} required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" placeholder="••••••••" value={password}
                  onChange={e => setPassword(e.target.value)} required />
              </div>
            </div>
            {error && <div className="auth-error">{error}</div>}
            <button className="btn-primary full" type="submit" disabled={loading}>
              {loading ? <><span className="spinner" /> Signing in...</> : "Sign In →"}
            </button>
          </form>
          <div className="auth-footer" style={{ marginTop:12 }}>
            <Link to="/forgot-password" style={{ color:"var(--muted)", fontSize:13 }}>Forgot password?</Link>
          </div>
          <div className="auth-footer">
            Don't have an account? <Link to="/signup">Sign up free</Link>
          </div>
        </div>
      </div>
    </>
  );
}
